import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { PublisherResource, publishersPost } from '~/generated';
import { extractData } from '~/utils/query-utils';
import { PublisherParam } from '~/generated';

type Publisher = Omit<PublisherResource, 'partner' | 'congregation'> & {
  partner?: number | null;
  congregation: number | null;
};
type PublisherWithoutId = Omit<
  PublisherResource,
  'id' | 'partner' | 'congregation'
> & {
  partner?: number | null;
  congregation: number | null;
};

export const useCreatePublisher = (
  options: UseMutationOptions<
    Publisher,
    unknown,
    PublisherWithoutId,
    unknown
  > = {}
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (publisherParam: PublisherWithoutId) => {
      const publisher = await extractData(
        publishersPost({
          body: publisherParam as unknown as PublisherParam,
          responseType: 'json',
        })
      );
      return publisher as unknown as Publisher;
    },
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({
        queryKey: ['publishers'],
      });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
